// extracted by mini-css-extract-plugin
export var dark = "r_rW";
export var darkcookie = "r_rX";
export var tintedcookie = "r_rY";
export var regularcookie = "r_rZ";
export var darkbase = "r_r0";
export var tintedbase = "r_r1";
export var regularbase = "r_r2";
export var darkraw = "r_r3";
export var tintedraw = "r_r4";
export var regularraw = "r_r5";
export var darkchick = "r_r6";
export var tintedchick = "r_r7";
export var regularchick = "r_r8";
export var darkherbarium = "r_r9";
export var tintedherbarium = "r_sb";
export var regularherbarium = "r_sc";
export var darkholiday = "r_sd";
export var tintedholiday = "r_sf";
export var regularholiday = "r_sg";
export var darkoffline = "r_sh";
export var tintedoffline = "r_sj";
export var regularoffline = "r_sk";
export var darkorchid = "r_sl";
export var tintedorchid = "r_sm";
export var regularorchid = "r_sn";
export var darkpro = "r_sp";
export var tintedpro = "r_sq";
export var regularpro = "r_sr";
export var darkrose = "r_ss";
export var tintedrose = "r_st";
export var regularrose = "r_sv";
export var darktimes = "r_sw";
export var tintedtimes = "r_sx";
export var regulartimes = "r_sy";
export var darkwagon = "r_sz";
export var tintedwagon = "r_sB";
export var regularwagon = "r_sC";